import * as Yup from 'yup';

export const quizSettingsValidation = Yup.object({
  scoreType: Yup.string().required('Required'),
  passingScore: Yup.number().required('Required'),
  timeLimit: Yup.number().required('Required'),
});

export const convertSecondsToTimeFormat = (totalSeconds) => {
  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return { days, hours, minutes };
};

export const convertTimeBeforeNextAttemptToSeconds = ({
  days,
  hours,
  minutes,
}) => {
  const daysInSeconds = days * 24 * 60 * 60;
  const hoursInSeconds = hours * 60 * 60;
  const minutesInSeconds = minutes * 60;
  return daysInSeconds + hoursInSeconds + minutesInSeconds;
};
